/** @module Enums */ /** typedoc */

export enum GenresEnum {
    Alternative = 'Alternative',
    Audiobooks = 'Audiobooks',
    Blues = 'Blues',
    ChildrensMusic = 'ChildrensMusic',
    Classical = 'Classical',
    Comedy = 'Comedy',
    Country = 'Country',
    Dance = 'Dance',
    Electronic = 'Electronic',
    Folk = 'Folk',
    HipHopRap = 'HipHopRap',
    Holiday = 'Holiday',
    Inspirational = 'Inspirational',
    Jazz = 'Jazz',
    Latin = 'Latin',
    NewAge = 'NewAge',
    Opera = 'Opera',
    Pop = 'Pop',
    Rock = 'Rock',
    RBSoul = 'RBSoul',
    Reggae = 'Reggae',
    Soundtrack = 'Soundtrack',
    SpokenWord = 'SpokenWord',
    Vocal = 'Vocal',
    World = 'World'
}
